import React from 'react';

type Props = {
  isCalendar: boolean,
  onNavTodayClick?: (arg?: any) => void,
}

const NavToday = (props: Props): React.ReactElement => {
  const { isCalendar, onNavTodayClick } = props;
  if (!isCalendar) {
    return (
      <button type="button" className="btn today-btn js-curr-week invisible">Today</button>
    );
  }

  return (
    <button
      type="button"
      className="btn today-btn js-curr-week"
      onClick={() => onNavTodayClick && onNavTodayClick('to-today')}
    >
      Today
    </button>
  );
};

export default NavToday;
